<template>
  <div id="post-sobre" class="mx-5">
    <div v-if="locale == 'pt'">
      <h2 class="mb-3">Sobre a Sorrifácil</h2>
      <p>
        É através do sorriso que nos conectamos com as pessoas. Entregamos aos
        pacientes muito mais que um atendimento humanizado, mas tratamentos
        odontológicos de excelência e acessíveis. Acreditamos que um sorriso
        saudável pode trazer segurança, felicidade, bem-estar, reconhecimento e
        autoestima.
      </p>
      <p>
        Estamos há 19 anos conquistando sorrisos, com mais de 110 clínicas
        odontológicas no Brasil e 3 clínicas no Uruguai. Para ampliar a atuação
        e compartilhar o conhecimento adquirido ao longo da nossa trajetória,
        criamos o Instituto Sorrifácil. Com tudo que há de mais moderno e
        inovador para a prática do ensino e atendimentos odontológicos, o
        Instituto Sorrifácil se destaca como referência na prática da
        odontologia no Brasil. O principal objetivo é promover a boa prática no
        atendimento odontológico por meio da capacitação de profissionais,
        inovação e avanços tecnológicos. O Instituto Sorrifácil possui 4 pilares
        que são: Educação, Clínica, Inovação Tecnológica e Projeto Social.
      </p>
      <p>
        Nossas clínicas estão equipadas com o que há de mais moderno na
        odontologia, com tecnologias de última geração, além de transmitirem o
        conforto e qualidade que você precisa para realizar qualquer
        procedimento.
      </p>
      <p>
        Venha nos visitar e entender como podemos ajudar a transformar o seu
        sorriso.
      </p>
    </div>

    <div v-if="locale == 'es'">
      <h2 class="mb-3">{{ $t("Sobre a Sorrifácil") }}</h2>
      <p>
        Es a través de la sonrisa que conectamos con las personas. entregamos a
        pacientes mucho más que un cuidado humanizado, sino tratamientos
        excelentes y asequibles servicios dentales. Creemos que una sonrisa La
        salud puede traer seguridad, felicidad, bienestar, reconocimiento y
        autoestima.
      </p>
      <p>
        Llevamos 19 años conquistando sonrisas, con más de 110 clínicas dentales
        en Brasil y 5 clínicas en Uruguay. Para ampliar el alcance y compartir
        los conocimientos adquiridos a lo largo de nuestra trayectoria, creamos
        el Instituto Sorrifácil. Con todo lo más moderno y innovador para la
        práctica de la enseñanza y el cuidado dental, el El Instituto Sorrifácil
        se destaca como un referente en la práctica de odontología en Brasil. El
        objetivo principal es promover las buenas prácticas en atención
        odontológica a través de la formación de profesionales, innovación y
        avances tecnológicos. El Instituto Sorrifácil tiene 4 pilares los cuales
        son: Educación, Clínica, Innovación Tecnológica y Proyecto Social.
      </p>
      <p>
        Nuestras clínicas están equipadas con los equipos más modernos del
        odontología, con tecnologías de punta, además de transmitir la comodidad
        y calidad que necesitas para realizar cualquier procedimiento.
      </p>
      <p>
        Venga a visitarnos y comprenda cómo podemos ayudar a transformar su
        sonrisa.
      </p>
    </div>
  </div>
</template>

<script setup>
const { locale } = useI18n();
</script>

<script>
export default {
  name: "PostSobre",
};
</script>
